import React from 'react';
import theme from '../../theme';
import { Typography } from '@material-ui/core';
import { Colors } from '../../constants';

const ProgressBar = (bio: { bio: string }) => {
    const characterMinimum = 250;
    const weakThreshold = 0.33;
    const moderateThreshold = 1;
    const progressColors = {
        weak: theme.palette.error.main,
        moderate: Colors.olive,
        great: theme.palette.primary.main,
    };

    let bioPercent = bio.bio.length / characterMinimum;

    let bioLengthText =
        bioPercent >= moderateThreshold
            ? 'Great'
            : bioPercent > weakThreshold && bioPercent < moderateThreshold
            ? 'Getting there'
            : 'Short';
    let progressWidth = bioPercent <= 1 ? 100 * bioPercent + '%' : '100%';

    return (
        // entire progress bar
        <div
            style={{
                width: '100%',
                backgroundColor: theme.palette.primary.light,
                height: '6px',
                borderRadius: '20px',
                marginBottom: 5,
            }}
        >
            {/* filled in progress bar */}
            <div
                style={{
                    width: progressWidth,
                    backgroundColor:
                        bioPercent >= moderateThreshold
                            ? progressColors.great
                            : bioPercent > weakThreshold && bioPercent < moderateThreshold
                            ? progressColors.moderate
                            : progressColors.weak,
                    height: '100%',
                    borderRadius: '20px',
                    transitionDuration: '150ms',
                    marginBottom: 5,
                }}
            ></div>
            <Typography variant="subtitle1">Length: {bioLengthText}</Typography>
            <Typography variant="subtitle2">A detailed bio helps care providers get to know your family.</Typography>
        </div>
    );
};

export default ProgressBar;
